import { Link } from "react-router-dom";
import { BrandButton as Button } from "@/components";
import styles from "@/styles/Gradients.module.css";
import typo from "@/styles/Typography.module.css";
import { useState } from "react";
import Spinner from 'react-bootstrap/Spinner';
import { useMsal } from "@azure/msal-react";
import { STORAGE_KEYS } from "@/constants/storage";
import SafeLocalStorage from "@/utils/safeLocalStorage";

export default function Home() {
  const [loading, setLoading] = useState(false);
const { instance } = useMsal();

const handleLogin = () => {
      setLoading(true);
instance.loginRedirect({
scopes: ["openid", "profile", "email"]
});
};

  return (
    <>
      <div
        className={`container-fluid ${styles.sunshine} py-5`}
        style={{ minHeight: "40rem" }}
      >
        <div className="row g-4 mt-5">
          <div>
            <div
              className={`${typo.cardWhite} `}
              style={{ width: "60%", margin: "0 auto", paddingTop: "3rem", paddingBottom: "3rem" }}
            >
              <div>
                <div className="text-center">
                  <h1>Admin Portal</h1>
                  <p className="py-4"style={{ fontSize: "var(--font-3xl)" }}>
                    Login here for Admins only
                  </p>
                  
                  <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: "1rem" }}>
                    
                    {/* Go to MS EntraId login */}
                    <Button onClick={handleLogin}>Log in with MS EntraId</Button>
                    {loading && (
    <Spinner animation="border" role="status">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>

        </div>
      </div>
    </>
  );
}
